var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProcessed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_1231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6804 23.9998C30.8937 23.8131 25.3337 29.2664 25.3337 35.9998H22.947C22.347 35.9998 22.0537 36.7198 22.4804 37.1331L26.2004 40.8664C26.467 41.1331 26.8804 41.1331 27.147 40.8664L30.867 37.1331C31.2804 36.7198 30.987 35.9998 30.387 35.9998H28.0004C28.0004 30.7998 32.2404 26.5998 37.467 26.6664C42.427 26.7331 46.6004 30.9064 46.667 35.8664C46.7337 41.0798 42.5337 45.3331 37.3337 45.3331C35.187 45.3331 33.2004 44.5998 31.627 43.3598C31.0937 42.9464 30.347 42.9864 29.867 43.4664C29.307 44.0264 29.347 44.9731 29.9737 45.4531C32.0004 47.0531 34.547 47.9998 37.3337 47.9998C44.067 47.9998 49.5204 42.4398 49.3337 35.6531C49.1604 29.3998 43.9337 24.1731 37.6804 23.9998ZM37.0004 30.6664C36.4537 30.6664 36.0004 31.1198 36.0004 31.6664V36.5731C36.0004 37.0398 36.2537 37.4798 36.6537 37.7198L40.8137 40.1864C41.2937 40.4664 41.907 40.3064 42.187 39.8398C42.467 39.3598 42.307 38.7464 41.8404 38.4664L38.0004 36.1864V31.6531C38.0004 31.1198 37.547 30.6664 37.0004 30.6664Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_1231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcessed);
export default __webpack_public_path__ + "static/media/IconProcessed.6be3c7b8de22a58a2cad93ca60f541b9.svg";
export { ForwardRef as ReactComponent };